// src/icons/svgs/error-triangle.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgErrorTriangle = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { fill: "#FDFDFD", stroke: "#E64980", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.333, d: "M10.254 3.66 1.607 18.24a2.08 2.08 0 0 0 .733 2.809c.307.182.656.28 1.013.284h17.294a2 2 0 0 0 1.013-.284c.308-.183.562-.444.739-.756a2.08 2.08 0 0 0-.006-2.053L13.746 3.66a2.05 2.05 0 0 0-.744-.728 2.026 2.026 0 0 0-2.748.727" }),
  /* @__PURE__ */ jsx("path", { stroke: "#E64980", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.333, d: "M12 9.333V14" }),
  /* @__PURE__ */ jsx("path", { fill: "#E64980", d: "M13 17a1 1 0 1 1-2-.002A1 1 0 0 1 13 17" })
] });
var ForwardRef = forwardRef(SvgErrorTriangle);
var error_triangle_default = ForwardRef;
export {
  error_triangle_default as ErrorTriangle
};
